import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {ProjectsFilter} from '../components/ProjectsFilter/ProjectsFilter';
import {ProjectsTable} from '../components/ProjectsTable/ProjectsTable';
import {ProjectsFooter} from '../components/ProjectsFooter/ProjectsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function ProjectsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'projects-list-card'}>
      <ProjectsFilter/>
      <ProjectsTable/>
      <FooterBar><ProjectsFooter/></FooterBar>
    </Card>
  );
}
